// src/pages/Login.jsx
import { useState } from "react";
import { toast } from 'react-toastify';
import { useAuth } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { IoHome } from "react-icons/io5";
import "./Login.css"

const API = process.env.REACT_APP_API;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();
  

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API}/api/users/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok){
        toast.error(data.message);
        return;
        }

        login(data.user, data.token); // שמירת user + JWT  
        navigate("/");
        toast.success(`שלום ${data.user.name}`);
        
    } catch (err) {
        toast.error('שגיאה בשרת, נסה שוב מאוחר יותר');
    }
  };

  return (
    <div className="login-wrapper">
      {/* אייקון הבית בפינה שמאלית עליונה */}
      <div className="home-icon" onClick={() => navigate("/")}>
        <IoHome title="עמוד הבית" size={30} />
      </div>
      <form className="login-form"onSubmit={handleSubmit}>
      <h2>התחברות - למנהל המערכת בלבד</h2>
        <input
          type="email"
          placeholder="דוא״ל"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="סיסמה"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">התחבר</button>
      </form>
    </div>
  );
};

export default Login;
